export type FlagKey =
  | "backoffice-test-feature"
  | "backoffice-member-feedback-toggle"
  | "backoffice-algolia-person-index"
  | "backoffice-prorated-product-price"
  | "backoffice-person-note-references"
  | "backoffice-background-check-staff-visibility"
  | "backoffice-background-check-staff-send-invitation"
  | "backoffice-background-check-staff-create-order"
  | "backoffice-activities-screen"
  | "backoffice-education-credentials"
  | "backoffice-education-delete-program-level"
  | "backoffice-manage-lifelong-learning"
  | "backoffice-facility-section-change"
  | "backoffice-facility-merge-purge"
  | "backoffice-uncollectible-orders"
  | "m360-timeline"
  | "pga-career-targets"
  | "pga-career-plan"
  | "backoffice-create-test-person"
  | "backoffice-grp"
  | "commission-grp-platform"
  | "backoffice-section-governance"
  | "backoffice-section-roster-activity"
  | "backoffice-sections-catalog"
  | "backoffice-person-profile-documents"
  | "backoffice-pat-result-volume"
  | "backoffice-bgc-staff-disposition-edit"
  | "m360-department-task-queue"
  | "backoffice-career-services-dashboard"
  | "m360-quick-action-menus-redesign"
  | "m360-private-team-task-visibility"
  | "backoffice-scorm-courses"
  | "backoffice-system-preferences"
  | "backoffice-navigation-preferences"
  | "backoffice-team-task-notifications"
  | "backoffice-pgm-transcript-print"
  | "backoffice-job-applicant-count-estimate"
  | "backoffice-prospect-program-tab"
  | "applications-membership"
  | "membership-beneficiary-contact-info"
  | "membership-sms-consent";

export const MEMBERSHIP_SMS_CONSENT_FLAG = "membership-sms-consent" satisfies FlagKey;

export type FlagValue = boolean | string;

export type FlagRecord = Partial<Record<FlagKey, FlagValue>>;
